module.exports = function isFunction(arg) {
  return typeof arg === 'function';
};
